export interface AppInfo {
  readonly tag: string;
  readonly pipelineId: string;
}
// Gets stamped by CI
export const appInfo: AppInfo = {
  pipelineId: "214079",
  tag: "3.0.1",
};
